<template>
    <div class="position-absolute d-flex flex-row justify-content-center"
         style="top:0;left:0;width:100vw;height:100vh;z-index:1050;"
         :class="{'pointer-events-none': !visible}">
        <div>
            <transition>
                <div v-show="visible" class="card card-body shadow-xl mt-10">
                    <div class="font-weight-bold text-xl">
                        {{ __('actions.provide_shipping_details') }}
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">{{ __('orders.shipping.provider') }}</label>
                        <input type="text" class="form-control form-control-solid" placeholder="DHL, UPS, FedEx, ..."
                               v-model="shippingProvider">
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">{{ __('orders.shipping.tracking_code') }}</label>
                        <input type="text" class="form-control form-control-solid" placeholder="000000000000000"
                               v-model="trackingCode">
                    </div>
                    <div>
                        <div class="btn-group">
                            <button class="btn btn-success" @click="$emit('submit', shippingProvider, trackingCode)">
                                <i class="fas fa-check"/>
                                {{ __('actions.submit') }}
                            </button>
                            <button class="btn btn-secondary" @click="$emit('skip')">
                                <i class="fas fa-long-arrow-alt-right"/>
                                {{ __('actions.provide_later') }}
                            </button>
                        </div>
                        <button class="btn btn-secondary ml-1" @click="$emit('abort')">
                            <i class="fas fa-times"/>
                            {{ __('actions.abort') }}
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order: Object,
        visible: Boolean,
    },

    data() {
        return {
            shippingProvider: null,
            trackingCode: null,
        };
    },
};
</script>

<style>
.v-enter-active,
.v-leave-active {
    transition: 0.35s ease-out;
}

.v-enter-from,
.v-leave-to {
    transform: translateY(-10vh);
}
</style>
